import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Box } from '@mui/material';
import { FixedCenterCircularProgress } from '../progress/fixed-center-circular-progress';
import { DEFAULT_TABLE_COL_SPAN } from './utils';

export type TableLoadingProps = {
  /**
   * Columns to span. Pass the table's real column count for grids where it
   * varies, so the row covers the full width.
   */
  colSpan?: number;
};

export function TableLoading({ colSpan = DEFAULT_TABLE_COL_SPAN }: TableLoadingProps = {}) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Box justifyItems="center">
          <FixedCenterCircularProgress />
        </Box>
      </TableCell>
    </TableRow>
  );
}
